import * as React from "react";
import { connect } from "react-redux";
import { Modal, Button, Loader } from "semantic-ui-react";

import { Appointment } from "@teamprevent/common/calendar";
import { LinkObject } from "@teamprevent/common/model";

import { updateAssociatedManagers, updateAssociatedHrUsers, loadOhCaseDetail } from "../../crud/ohCase/actions";
import { CoreDetails as OhCaseCoreDetails } from "../../crud/ohCase/components/details/CoreDetails";
import { OhCase } from "../../crud/ohCase";

import { ImmunisationClearBanner } from "../../crud/ohCase/components/ImmunisationClearBanner";

import { AppointmentModalHeader } from "./AppointmentModalHeader";

interface OhCaseAppointmentModalOwnProps {
    onModalClose: () => void;
    ohCase: OhCase;
    selectedAppointment: Appointment;
    isModalOpen: boolean;
}

interface OhCaseAppointmentModalDispatchProps {
    updateAssociatedManagers: (customerId: string, ohCaseId: string, managers: LinkObject[]) => Promise<void>;
    updateAssociatedHrUsers: (customerId: string, ohCaseId: string, managers: LinkObject[]) => Promise<void>;
    refreshCase: (ohCaseId: string, customerId: string) => void;
}

class OhCaseAppointmentModalUnconnected extends React.Component<OhCaseAppointmentModalOwnProps & OhCaseAppointmentModalDispatchProps> {
    constructor(props: OhCaseAppointmentModalOwnProps & OhCaseAppointmentModalDispatchProps) {
        super(props);
    }

    public render() {
        return (
            <Modal open={this.props.isModalOpen} onClose={this.props.onModalClose} closeIcon>
                <AppointmentModalHeader appointment={this.props.selectedAppointment} />
                <ImmunisationClearBanner />
                <Modal.Content scrolling={!!this.props.ohCase}>{
                    this.props.selectedAppointment && this.props.ohCase ?
                        <OhCaseCoreDetails
                            refreshCase={this.props.refreshCase}
                            ohCase={this.props.ohCase}
                            customer={this.props.selectedAppointment.customer}
                            customerId={this.props.selectedAppointment.customer.id}
                            updateAssociatedManagers={this.props.updateAssociatedManagers}
                            updateAssociatedHrUsers={this.props.updateAssociatedHrUsers}
                        /> :
                        <Loader active inline="centered" />
                }</Modal.Content>
                <Modal.Actions>
                    {this.props.selectedAppointment && this.props.ohCase &&
                        <><a
                            // eslint-disable-next-line max-len
                            href={`/customers/${this.props.selectedAppointment.customer.id}/employeeRecords/${this.props.ohCase.employeeRecordId}/ohCases/${this.props.ohCase.id}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button>Case overview</Button>
                        </a>
                        <a
                            // eslint-disable-next-line max-len
                            href={`/customers/${this.props.selectedAppointment.customer.id}/employeeRecords/${this.props.ohCase.employeeRecordId}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button>Employee record</Button>
                        </a></>}
                </Modal.Actions>
            </Modal>
        );
    }
}

const mapDispatchToProps = (dispatch: any): OhCaseAppointmentModalDispatchProps => {
    return {
        updateAssociatedManagers: (customerId: string, ohCaseId: string, managers: LinkObject[]) =>
            dispatch(updateAssociatedManagers(customerId, ohCaseId, managers)),
        updateAssociatedHrUsers: (customerId: string, ohCaseId: string, managers: LinkObject[]) =>
            dispatch(updateAssociatedHrUsers(customerId, ohCaseId, managers)),
        refreshCase: (ohCaseId: string, customerId: string) => dispatch(loadOhCaseDetail({ ohCaseId, customerId }))
    };
};

export const OhCaseAppointmentModal = connect(null, mapDispatchToProps)(OhCaseAppointmentModalUnconnected);
